<template>
    <div>
        <form id="cnfmForm" name="cnfmForm" method="post" action="">
        </form>
        <v-dialog/>
    </div>
</template>

<script>
export default {
    name: "ResultKcbAuthPop",
    data() {
        return {
           kcbInfo:{ 
                rsltName: '',
                rsltBirthday: '',
                crdCd:'',
                crdNm:'',
                txSeqNo:'',
                rsltSexCd:'',
                rsltNtvFrnrCd:'',
                ciRqstDttm:'',
                rsltCd: '',
                rsltMsg: ''
           }
        }
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KCB 카드 결과 정보
         **/
        getInfo() {

             let mdlTkn =this.$route.query.MDL_TKN
           // let mdlTkn =this.$route.query.mdlTkn
          // alert(mdlTkn)

           if(mdlTkn){
               window.opener.cbAuthPop(mdlTkn)
               window.close()
           } else {
                alert('인증을 실패 했습니다.\n다시 시도해주세요.')
                window.close()
            }
        },
    },
}
</script>

<style scoped>

</style>